import { Form } from "src/app/models/form";
import { FormPropertyKey } from 'src/app/models/form-property-key';

export class FormExpand{

  // formHash:string;

  hash: string;
  type:'FormExpand';
  typeText:string = 'フォーム（エクスパンド）';

  form:Form;

  constructor(object = null){

    this.type = 'FormExpand';

    if(object){
      this.set(object);
    }
  };

  set(object){

    if(object.form?.hash){
      // this.formHash = object.formHash;
      this.hash = object.form.hash;
    }

    if(! this.form){
      this.form = new Form();
    }

    this.form.setObject(object.form);
  }

  getFormDatasObject(){
    const values = {};
    this.form.formPropertyKeys.forEach((formPropertyKey:FormPropertyKey) => {
      values[formPropertyKey.id] = formPropertyKey.value;
    });
    return values;
  }
}
